import React from 'react';

import { InfoMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';

import { useConfig } from '../../../defaultConfig';
import type { TransactionStatus } from '../../../generated-types';
import useTranslation from '../../../hooks/useTranslation';

interface Props {
    type: TransactionStatus | undefined;
}

const ReservationWarning: React.FC<Props> = ({ type }) => {
    const { featureToggles } = useConfig();
    const translated = useTranslation();
    if (!featureToggles.enableTransactionDetailsReservedFields || type === 'BOOKED') return <></>;

    return (
        <InfoMessage
            className="transaction-details__attention_message"
            text={`${translated.amountNotAvailableWithDate}`}
            icon={IconTypes.INFO_20}
        />
    );
};

export default ReservationWarning;
